import Cookies from "js-cookie";
import { nanoid } from 'nanoid';
import global from "../config/global";
import request from "../secrets-web/src/utils/request";
import auth from '../secrets-web/src/services/auth';
import coreServices from "../secrets-web/src/services/core";

import {
  getRouterByLocation
} from "../secrets-web/src/utils/common";

function cs_locker_token() {
  return Cookies.get("cs_locker_token")
}

function device_id() {
  return Cookies.get("device_id")
}

function random_string() {
  return nanoid()
}

function set_device_id(deviceId) {
  const expireTime = 50 * 365
  Cookies.set('device_id', deviceId, {
    expires: expireTime,
    domain: window.location.host
  })
}

async function redirect_login() {
  await coreServices.lock();
  const currentPage = getRouterByLocation(window.location)
  let isAdmin = !!global.routers.ADMIN_ROUTERS.find((r) => r.name === currentPage?.name)

  if (auth.access_token()) {
    if (!currentPage?.not_auth && currentPage?.name !== 'LOCK') {
      global.navigate('LOCK', {}, { return_url: encodeURIComponent(isAdmin && currentPage?.name !== 'ADMIN_ERROR' ? `${window.location.pathname}${window.location.search}` : '/') })
    }
  } else {
    global.navigate('LOGIN')
  }
}

async function locker_access_token() {
  return await request({
    url: global.endpoint.ACCESS_TOKEN,
    method: "post",
    data: {
      SERVICE_SCOPE: global.constants.SERVICE_SCOPE,
      SERVICE_URL: "/sso"
    }
  });
}

async function get_factor2() {
  return request({
    url: global.endpoint.USERS_ME_FACTOR2,
    method: 'get',
  })
}

async function logout() {
  if (auth.access_token()) {
    try {
      await request({
        url: global.endpoint.LOGOUT,
        method: 'post',
      })
    } catch (error) {
      
    }
  }
  await coreServices.logout()
  Cookies.remove('access_token')
  Cookies.remove('account_info')
  window.location.replace(`${global.urls.LANDING_URL}/secrets?logout=1`)
}

auth.logout = logout;

export default {
  ...auth,
  redirect_login,
  cs_locker_token,
  device_id,
  locker_access_token,
  set_device_id,
  random_string,
  get_factor2
};
